// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PortfolioComparisonAssociationFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'comparedPortfolioId': !exists(json, 'comparedPortfolioId') ? undefined : json['comparedPortfolioId'],
        'comparatorPortfolioId': !exists(json, 'comparatorPortfolioId') ? undefined : json['comparatorPortfolioId'],
    };
}
export function PortfolioComparisonAssociationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'comparedPortfolioId': value.comparedPortfolioId,
        'comparatorPortfolioId': value.comparatorPortfolioId,
    };
}
